import { render, staticRenderFns } from "./politicaPrivacidade.vue?vue&type=template&id=14044376&scoped=true"
import script from "./politicaPrivacidade.vue?vue&type=script&lang=js"
export * from "./politicaPrivacidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14044376",
  null
  
)

export default component.exports